/**
 * 平台检测工具函数
 */

/** 当前是否为 Mac 系统 */
export function isMac(): boolean {
    if (typeof navigator === 'undefined') return false
    return navigator.userAgent.toLowerCase().includes('mac')
}

/** 返回修饰键标签：Mac 显示 ⌘，其他显示 Ctrl */
export function modLabel(): string {
    return isMac() ? '⌘' : 'Ctrl'
}
/** 返回 Alt 键标签：Mac 显示 ⌥，其他显示 Alt */
export function altLabel(): string {
    return isMac() ? '⌥' : 'Alt'
}
/** 返回 Shift 键标签：Mac 显示 ⇧，其他显示 Shift */
export function shiftLabel(): string {
    return isMac() ? '⇧' : 'Shift'
}
